export const RequestEntitiesByLayerType = `
    query requestEntitiesByLayerType ($type: String!) {
        layerByType (type: $type) {
            type
            entitiesByLayerid {
                nodes {
                    fullUid
                }
            }
        }
    }
`
